import { FieldSchema } from "../../../Schema";

/**
 * The cluster this record belongs to, when it is a sub-equipment.
 *
 * Owned by the cluster screens, which add and remove members; an equipment form never edits
 * it. Present on every CLUSTER-SUBEQUIPMENT record, so both schemas need to know it exists.
 */
export const clusterId: FieldSchema = {
  name: "clusterId",
  dataTransform: {
    toGraphql: undefined,
  },  
  display: { displayed: false },
  grid: { displayed: false },
  form: { label: "Cluster id", disabled: true, displayed: false },
};
